import { config } from '@/constants'

export default function cloudinaryImgUrl(imageKey, options = '', ext = 'jpg') {
  return `https://res.cloudinary.com/${
    config.cloudinary.cloudName
  }/image/upload/${options ? `${options}/` : ''}v${Math.floor(
    Date.now() / 1000
  )}/${imageKey}.${ext}`
}
